// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.picker-dashboard {
  position: absolute;
  top: 40px;
  right: 10px;
  box-shadow: 0px 4px 8px rgba(73, 72, 55, 0.5);
  border-radius: 4px;
  background-color: var(--White);
  overflow: hidden;
  z-index: 11; }
  .picker-dashboard_buttons {
    border-top: 1px solid #eff2f7;
    padding: 9px 20px;
    display: flex;
    justify-content: flex-end;
    gap: 20px; }

.rdrWeekDays {
  background-color: #e0e0e0; }

.rdrWeekDay {
  color: #9e9e9e;
  overflow: hidden; }
  .rdrWeekDay:first-letter {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    padding: 0px 18px; }

.rdrStaticRange:nth-child(-n+2) {
  display: block; }

.rdrStaticRange:nth-child(n+3) {
  display: none; }
`, "",{"version":3,"sources":["webpack://./src/components/dayPicker/dayPicker.scss"],"names":[],"mappings":"AAAA;EACI,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,6CAA6C;EAC7C,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;EAChB,WAAW,EAAA;EACX;IACE,6BAA6B;IAC7B,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,SAAS,EAAA;;AAGb;EACE,yBAAyB,EAAA;;AAE3B;EACE,cAAc;EACd,gBAAgB,EAAA;EAFlB;IAII,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,iBAAiB,EAAA;;AAGrB;EAEI,cAAc,EAAA;;AAFlB;EAKI,aAAa,EAAA","sourcesContent":[".picker-dashboard {\n    position: absolute;\n    top: 40px;\n    right: 10px;\n    box-shadow: 0px 4px 8px rgba(73, 72, 55, 0.5);\n    border-radius: 4px;\n    background-color: var(--White);\n    overflow: hidden;\n    z-index: 11;\n    &_buttons {\n      border-top: 1px solid #eff2f7;\n      padding: 9px 20px;\n      display: flex;\n      justify-content: flex-end;\n      gap: 20px;\n    }\n  }\n  .rdrWeekDays {\n    background-color: #e0e0e0;\n  }\n  .rdrWeekDay {\n    color: #9e9e9e;\n    overflow: hidden;\n    &:first-letter {\n      font-weight: 400;\n      font-size: 14px;\n      line-height: 24px;\n      padding: 0px 18px;\n    }\n  }\n  .rdrStaticRange{\n    &:nth-child(-n+2) {\n      display: block;\n    }\n    &:nth-child(n+3) {\n      display: none;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
